import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { SectionTitle } from './section-title';
export function TrackingTitle(_ref) {
  var isMultiplePackage = _ref.isMultiplePackage,
      packageIndex = _ref.packageIndex;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  if (isMultiplePackage) {
    return /*#__PURE__*/_jsx(SectionTitle, {
      children: t('PACKAGE', {
        PACKAGE_INDEX: packageIndex + 1
      })
    });
  }

  return /*#__PURE__*/_jsx(SectionTitle, {
    children: t('TRACKING_JOURNEY')
  });
}